import { createRequestActions } from '../utils';
import * as actionTypes from './actionTypes';

export const listActions = createRequestActions(actionTypes.ACTION_LIST);
